export const CUSTOMER_GROUP_KEY = 'NY-CUSTOMER-GROUP';
export const CUSTOMER_GROUP_SERVICE_KEY = 'NY_CUSTOMER_GROUP_SERVICE';

declare global {
  // noinspection JSUnusedGlobalSymbols
  interface Window {
    NY_CUSTOMER_GROUP_SERVICE: ICustomerGroupService;
  }
}

export interface ICustomerGroupService {
  setCustomerGroup(group: string): void
  getCustomerGroup(): string
  checkForCustomerGroup(countryCode: string): void
  toPath(): string
}

export function getCustomerGroupService(): ICustomerGroupService {
  const cs = window[CUSTOMER_GROUP_SERVICE_KEY];
  if (cs) {
    return cs as ICustomerGroupService;
  }
  return null
}

export class CustomerGroupService {

  setCustomerGroup(group: string) {
    sessionStorage.setItem(CUSTOMER_GROUP_KEY, group);
  }

  getCustomerGroup() {
    const group = sessionStorage.getItem(CUSTOMER_GROUP_KEY);
    if (group) return group;
  }

  toPath() {
    switch (this.getCustomerGroup()) {
      case 'FEMALE':
        return 'women';
      case 'MALE':
        return 'men';
      default:
        return '';

    }
  }

  checkForCustomerGroup(countryCode: string) {
    const cg = sessionStorage.getItem(CUSTOMER_GROUP_KEY);

    if (cg === 'MALE') {
      window.location.href = `${countryCode}/men`;
    }

    else if (cg === 'FEMALE') {
      window.location.href = `${countryCode}/women`;
    }
  }
}
